import { useState } from 'react';
import type { ChangeEvent } from 'react';
import { __ } from '@/hub-shared/utils/i18n';
import type { ComptExpertOffice } from '../utils/comptExpertConnection';

type ComptExpertOfficeChooserProps = {
  /** Unique per card: radio groups of two cards must not share a name. */
  radioName: string;
  offices: ComptExpertOffice[];
  pending: boolean;
  disabled: boolean;
  disabledTitle?: string;
  onSubmit: (officeId: string) => void;
  onCancel: () => void;
};

const ComptExpertOfficeChooser = ({
  radioName,
  offices,
  pending,
  disabled,
  disabledTitle,
  onSubmit,
  onCancel,
}: ComptExpertOfficeChooserProps) => {
  const [selectedOfficeId, setSelectedOfficeId] = useState<string | null>(null);

  return (
    <fieldset className="api-connection-card__actions">
      <legend>{__('Choisissez le cabinet JeSignExpert à relier à 13 %')}</legend>
      {offices.map((office) => (
        <label key={office.id}>
          <input
            type="radio"
            name={radioName}
            value={office.id}
            checked={selectedOfficeId === office.id}
            disabled={disabled || pending}
            onChange={(event: ChangeEvent<HTMLInputElement>) => setSelectedOfficeId(event.target.value)}
          />
          {office.name.trim() !== '' ? office.name : office.id}
        </label>
      ))}
      <button
        type="button"
        className="btn-secondary"
        disabled={disabled || pending || selectedOfficeId === null}
        title={disabled ? disabledTitle : undefined}
        onClick={() => {
          if (disabled || pending || selectedOfficeId === null) {
            return;
          }
          onSubmit(selectedOfficeId);
        }}
      >
        {pending ? __('Liaison...') : __('Relier ce cabinet')}
      </button>
      <button
        type="button"
        className="btn-tertiary --small"
        disabled={pending}
        onClick={onCancel}
      >
        {__('Annuler')}
      </button>
    </fieldset>
  );
};

export default ComptExpertOfficeChooser;
